import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { createRef, Fragment, memo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import { Icon, } from '../Icon/index';
import { Popover, PopoverContent, } from '../Popover/index';
import { sizes, textFontSizes, } from './constants';
const iconSizes = {
    [sizes.large]: 'medium',
    [sizes.medium]: 'small',
    [sizes.small]: 'extraSmall',
};
const handleKeyPress = (func) => ({ key = '', }) => ((key === 'Enter'
    || key === 'Space')
    ? func
    : () => { });
const defaultProps = {
    contentRef: createRef(),
    open: false,
    size: sizes.medium,
    targetRef: createRef(),
    toggleDropdown: () => { },
    value: null,
    zIndex: 999999,
};
const DropdownTextStateless = ({ children, contentRef = defaultProps.contentRef, label, open = defaultProps.open, size = defaultProps.size, targetRef = defaultProps.targetRef, toggleDropdown = defaultProps.toggleDropdown, value, zIndex = defaultProps.zIndex, }) => (_jsxs(Fragment, { children: [_jsxs("div", Object.assign({ css: css `
        align-items: center;
        cursor: pointer;
        display: inline-flex;
        font-family: 'Gotham', 'Helvetica', 'Arial', sans-serif;
        font-size: ${textFontSizes[size]};
        justify-content: flex-start;
        outline: 0;
        user-select: none;
      `, onClick: toggleDropdown, onKeyPress: handleKeyPress(toggleDropdown), ref: targetRef, role: "button", tabIndex: 0 }, { children: [_jsx("div", Object.assign({ css: css `
            display: inline-flex;
            margin-right: 0.6rem;
          ` }, { children: _jsx(Icon, { size: iconSizes[sizes.small], type: "arrow-down" }) })), label, value ? ` : ${value}` : null] })), _jsx(Popover, Object.assign({ open: open, ref: contentRef, zIndex: zIndex }, { children: _jsx(PopoverContent, Object.assign({ css: css `
            margin-top: ${styleUtils.rem(6)};
          ` }, { children: children })) }))] }));
const MemoizedDropdownTextStateless = memo(DropdownTextStateless);
export { MemoizedDropdownTextStateless as DropdownTextStateless };
// MC-1068 Temporary hack for Storybook.
export default DropdownTextStateless;
